export default __webpack_public_path__ + "static/media/satellite.929def1b.svg";